import { render, staticRenderFns } from "./DashboardAX.vue?vue&type=template&id=42d309d2"
import script from "./DashboardAX.vue?vue&type=script&lang=js"
export * from "./DashboardAX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d309d2')) {
      api.createRecord('42d309d2', component.options)
    } else {
      api.reload('42d309d2', component.options)
    }
    module.hot.accept("./DashboardAX.vue?vue&type=template&id=42d309d2", function () {
      api.rerender('42d309d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/account/views/DashboardAX.vue"
export default component.exports